import React from 'react';
import { ArrowRightLeft } from 'lucide-react';
import { toast } from 'sonner';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuTrigger } from './ui/dropdown-menu';
import { resourcesAPI } from '../lib/api';

const DEST = { general: 'Generales (todo el equipo)', direction: 'De dirección (solo CEOs)' };

export const ResourceMoveMenu = ({ resource, onMoved }) => {
  const targets = Object.keys(DEST).filter((k) => k !== resource.scope);
  const move = async (scope) => {
    try { await resourcesAPI.move(resource.id, scope); toast.success(`Movido a ${DEST[scope]}`); onMoved(); }
    catch (e) { toast.error(e.message || 'No se pudo mover'); }
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="text-muted-foreground hover:text-primary" title="Mover a otro nivel" data-testid={`resource-move-${resource.id}`}><ArrowRightLeft className="w-3.5 h-3.5" /></button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel className="text-xs">Mover a…</DropdownMenuLabel>
        {targets.map((t) => <DropdownMenuItem key={t} onClick={() => move(t)} data-testid={`resource-move-to-${t}-${resource.id}`}>{DEST[t]}</DropdownMenuItem>)}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
